import { Container, InfoCard, Title, Wrapper } from './UpcomingEvents.styles';

import { EventCollection } from './EventCollection';
import { EventProps } from '../Events/types';
import { FC } from 'react';
import { SCHEDULED_QUERY } from '../../../common/components/Filters/LocalFilter/constants';
import { getData } from 'services/api';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

const UpcomingEvents: FC = () => {
	const { t } = useTranslation();

	const fetchUpcomingEvents = (): Promise<EventProps[]> => getData(`/events?date=${SCHEDULED_QUERY}`);

	const { data: upcomingEvents } = useQuery({
		queryKey: ['upcomingEvents'],
		queryFn: fetchUpcomingEvents,
	});

	const hasEvents = !!upcomingEvents?.length;

	return (
		<Wrapper data-cy="upcoming-events-section">
			<Title element="h2">{t('upcomingEvents')}</Title>
			<Container>
				{hasEvents ? (
					<EventCollection events={upcomingEvents || []} />
				) : (
					<InfoCard
						title={t('upcomingEvents-title')}
						subtitle={t('upcomingEvents-subtitle')}
						icon="calendar"
						highlightBackground
					/>
				)}
			</Container>
		</Wrapper>
	);
};

export { UpcomingEvents };
